import { Vue } from 'vue-property-decorator';

import accountService from '@/services/account.service';
import errorsService from '@/services/errors.service';
import routeService from '@/services/route.service';

import { ICookiesResultModel, ICookieModel } from '@/models/cookie.model';

export default {
  triggerHistoryEvent(context: Vue) {
    if ((window as any) && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: 'gtm.historyChange',
        virtualPageURL: context.$router.currentRoute.fullPath
      });
    }
  },

  triggerPartnerRegisterConfirmEvent(context: Vue) {
    if ((window as any) && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: 'partnerRegisterConfirm',
        virtualPageURL: context.$router.currentRoute.fullPath
      });
    }
  },

  triggerFirstSignUpEvent(context: Vue) {
    if ((window as any) && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: 'sign_up_success',
        virtualPageURL: context.$router.currentRoute.fullPath
      });
    }
  },

  triggerSuccessfullLoginEvent(context: Vue) {
    if ((window as any) && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: 'log_in_success',
        virtualPageURL: context.$router.currentRoute.fullPath
      });
    }
  },

  enableAnalytics(context: Vue, isMarketing: boolean = false) {
    const cookieName = isMarketing ? "consent_marketing" : "consent_analytics";
    const now = new Date();

    if (context.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'LOCAL') {
      context.$cookies.set(cookieName, "1", new Date(now.setDate(now.getDate() + 365)), '/');
    }
    else {
      const domain = routeService.getDomain(context);
      context.$cookies.set(cookieName, "1", new Date(now.setDate(now.getDate() + 365)), '/', domain, true, "None");
    }
  },

  disableAnalytics(context: Vue, isMarketing: boolean = false) {
    const cookieName = isMarketing ? "consent_marketing" : "consent_analytics";

    if (context.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'LOCAL') {
      context.$cookies.remove(cookieName);
    }
    else {
      const domain = routeService.getDomain(context);
      context.$cookies.remove(cookieName, "/", domain);
    }
  },

  getCookiesList(context: Vue): Promise<Array<ICookieModel>> {
    const url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "cookie";

    return accountService.get<ICookiesResultModel>(context, url)
      .then(response => {
        return response.Cookies;
      })
      .catch(errors => {
        errorsService.handleErrors(context, errors);
        return Promise.reject();
      });
  },

  setConsentCookies(context: Vue) {
    const now = new Date();

    if (context.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'LOCAL') {
      context.$cookies.set("consent_cookies", "1", new Date(now.setDate(now.getDate() + 365)), '/');
    }
    else {
      const domain = routeService.getDomain(context);
      context.$cookies.set("consent_cookies", "1", new Date(now.setDate(now.getDate() + 365)), '/', domain, true, "None");
    }
  },

  deleteConsentCookies(context: Vue) {
    context.$cookies.remove("consent_cookies");
  },

  seeCookiePopup(context: Vue): Promise<any> {
    const url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "profile/user/" + context.$store.getters.user.Id + "/see-cookie-popup";

    return accountService.post(context, url, {}, { headers: { Authorization: "Bearer " + context.$store.getters.token.Value } })
  }
}
